import React from "react"
import ReactDOM from "react-dom"

export default function Menu() {
    return (
        <nav>
            <ul>
                <li><a href="#">Live</a></li>
                <li><a href="#">Push</a></li>
                <li><a href="#">Note</a></li>
                <li><a href="#">Link</a></li>
                <li><a href="#">Shop</a></li>
                <li><a href="#">Packs</a></li>
                <li><a href="#">Help</a></li>
                <li><a href="#">More +</a></li>
            </ul>
        </nav>
    )
}